import { useEffect, useState } from "react";
import { GET_ONBOARDING_CONTACTS } from "../../../../../config/Endpoints.js";
import { getApi } from "../../../../utils/api.ts";
import { accessToken } from "../../../../utils/auth.ts";
import { showError } from "../../../../utils/toast.ts";
import type { SelectOption } from "../../../ui/index.ts";

export function useInvitationContacts() {
  const [options, setOptions] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const controller = new AbortController();
    void getApi<{ id: number; fullName: string }[]>(GET_ONBOARDING_CONTACTS, accessToken(), "json", controller.signal)
      .then(({ data }) => {
        if (!controller.signal.aborted) setOptions(data.map((contact) => ({ value: String(contact.id), label: contact.fullName })));
      })
      .catch((error) => { if (!controller.signal.aborted) showError(error instanceof Error ? error.message : "Unable to load invitation contacts."); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, []);
  return { options, loading };
}
